$('#item').addClass('active')